import { render } from "./ElScrollTop.vue?vue&type=template&id=56e77cf4&scoped=true&lang=html"
import script from "./ElScrollTop.vue?vue&type=script&lang=js"
export * from "./ElScrollTop.vue?vue&type=script&lang=js"

import "./ElScrollTop.vue?vue&type=style&index=0&id=56e77cf4&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e77cf4"]])

export default __exports__